import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { Back, ButtonSmall, sendSelectClickSoundCommand } from 'react-wot-bootstrap'

import { KEY_CODES } from 'constants'
import ClanUnitsChannel from 'channels/clan_units'
import { getReactiveUpdateUrl } from 'helpers/reactivity'
import { selectUnit } from 'state/actions/clan_units'

import CreateUnitButton from '../CreateUnitButton/CreateUnitButton'
import Title from '../Title/Title'

import Squad from '../Squad/Squad'
import { UnitDataPropTypes } from '../../propTypes'

import {
    SQUAD_OF_MY_CLAN,
    TO_UNIT_MATCHING,
    UNIT_DESCRIPTION,
    UNIT_DESTROYED,
} from './constants'

import styles from './UnitPreview.scss'

export class UnitPreview extends React.Component {
    static propTypes = {
        unit: UnitDataPropTypes.isRequired,
        reactiveUpdateUrl: PropTypes.string,

        handleToBattleRoomsButtonClick: PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props)

        this.updateChannel(props.reactiveUpdateUrl)
    }

    componentWillMount() {
        window.addEventListener('keydown', this.onKeyDown)
    }

    componentWillUnmount() {
        this.updateChannel(null)
        window.removeEventListener('keydown', this.onKeyDown)
    }

    updateChannel(url) {
        if (this.channel) {
            this.channel.disconnect()
        }
        if (url) {
            this.channel = new ClanUnitsChannel(url)
        }
    }

    onBackClick = () => {
        sendSelectClickSoundCommand()

        this.props.handleToBattleRoomsButtonClick()
    }

    onKeyDown = event => {
        if (event.keyCode === KEY_CODES.ESCAPE) {
            this.props.handleToBattleRoomsButtonClick()
        }
    }

    render(){
        const { unit } = this.props
        const content = unit.is_destroyed ? (
            <div className={styles.unitDestroyed}>
                {UNIT_DESTROYED}
                <ButtonSmall onClick={this.onBackClick} >
                    {TO_UNIT_MATCHING}
                </ButtonSmall>
            </div>
        ) : (
            <Squad unitData={unit} forPreview />
        )

        const unitDescription = UNIT_DESCRIPTION(
            unit.type, unit.max_vehicle_level, unit.periphery.name,
        )
        return (
            <div className={styles.base}>
                <header className={styles.header}>
                    <Back
                        type='back'
                        caption={TO_UNIT_MATCHING}
                        onClick={this.onBackClick}
                        side='left'
                    />
                    <div>
                        <Title>
                            {SQUAD_OF_MY_CLAN}
                        </Title>
                        <h2 className={styles.subtitle}>
                            {unitDescription}
                        </h2>
                    </div>
                    <div className={styles.createDetachmentButton}>
                        <CreateUnitButton />
                    </div>
                </header>
                <main className={styles.squad}>
                    {content}
                </main>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    reactiveUpdateUrl: getReactiveUpdateUrl(state.settings.pushStreamHost, state.clan.units_channel),
})

const mapDispatchToProps = {
    handleToBattleRoomsButtonClick: selectUnit,
}

export default connect(mapStateToProps, mapDispatchToProps)(UnitPreview)



// WEBPACK FOOTER //
// ./containers/BattleRooms/components/UnitPreview/UnitPreview.jsx